import { Fragment } from "react";
import bgImage from "../assets/images/contactUs2.webp";
import HeroSection from "../components/HeroSection";
import ContactForm from "../components/ContactForm";

const ContactUs = () => {
  const heroContent =
    "Have questions or need expert steel detailing services? Reach out to SteelX Engineering today! Our team is ready to assist you with precision-driven solutions tailored to your project needs. Let’s build something exceptional together!";
  return (
    <Fragment>
      <HeroSection
        title="Contact Us"
        backgroundImage={bgImage}
        content={heroContent}
      />
      <ContactForm />
    </Fragment>
  );
};

export default ContactUs;
